import { render, staticRenderFns } from "./ArrowRightIcon.vue?vue&type=template&id=2df47350&"
import script from "./ArrowRightIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports